import { signal } from '@preact/signals-react';

export const openMenuId = signal<string | null>(null);
